/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAIDVCSupport: BridgeCommands.Command<
    {},
    Types.Share.Graphicssetting.GetAIDVCSupportReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetAIDVCSupport',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAIDVCState: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetAIDVCStateParameters,
    Types.Share.Graphicssetting.GetAIDVCStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetAIDVCState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAIDVCState: BridgeCommands.Command<
    Types.Share.Graphicssetting.SetAIDVCStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'SetAIDVCState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRealtimeAIDVCState: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetRealtimeAIDVCStateParameters,
    Types.Share.Graphicssetting.GetRealtimeAIDVCStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetRealtimeAIDVCState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleNIS2: BridgeCommands.Command<
    Types.Share.Graphicssetting.ToggleNIS2Parameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'ToggleNIS2',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetNIS2State: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetNIS2StateParameters,
    Types.Share.Graphicssetting.GetNIS2StateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetNIS2State',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetNIS2Sharpen: BridgeCommands.Command<
    Types.Share.Graphicssetting.SetNIS2SharpenParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'SetNIS2Sharpen',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAIHDRSupport_V2: BridgeCommands.Command<
    {},
    Types.Share.Graphicssetting.GetAIHDRSupport_V2Return
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetAIHDRSupport_V2',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAIHDRDisplayInfoForProcess: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetAIHDRDisplayInfoForProcessParameters,
    Types.Share.Graphicssetting.GetAIHDRDisplayInfoForProcessReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetAIHDRDisplayInfoForProcess',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAIHDRRealTimeState: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetAIHDRRealTimeStateParameters,
    Types.Share.Graphicssetting.GetAIHDRRealTimeStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetAIHDRRealTimeState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAIHDRState_V2: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetAIHDRState_V2Parameters,
    Types.Share.Graphicssetting.GetAIHDRState_V2Return
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetAIHDRState_V2',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAIHDRState_V2: BridgeCommands.Command<
    Types.Share.Graphicssetting.SetAIHDRState_V2Parameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'SetAIHDRState_V2',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGPUInfo: BridgeCommands.Command<
    {},
    Types.Share.Graphicssetting.GPUInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetGPUInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGenericInfo: BridgeCommands.Command<
    {},
    Types.Share.Graphicssetting.GenericInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetGenericInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUserPreferredLanguage: BridgeCommands.Command<
    {},
    Types.Share.Graphicssetting.LanguagePreference
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetUserPreferredLanguage',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterUserPreferredLanguageChangeNotification: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'RegisterUserPreferredLanguageChangeNotification',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UserPreferredLanguageChangeNotification: BridgeCommands.Command<
    {},
    Types.Share.Graphicssetting.LanguagePreference
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'UserPreferredLanguageChangeNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DlssOnGameLaunched: BridgeCommands.Command<
    Types.Share.Graphicssetting.DlssOnGameLaunchedParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'DlssOnGameLaunched',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetNGXOverrideSRState: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetNGXOverrideSRStateParameters,
    Types.Share.Graphicssetting.GetNGXOverrideSRStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetNGXOverrideSRState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetNGXOverrideRRState: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetNGXOverrideRRStateParameters,
    Types.Share.Graphicssetting.GetNGXOverrideRRStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetNGXOverrideRRState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetNGXOverrideFGState: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetNGXOverrideFGStateParameters,
    Types.Share.Graphicssetting.GetNGXOverrideFGStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetNGXOverrideFGState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetNGXOverrideFGState: BridgeCommands.Command<
    Types.Share.Graphicssetting.SetNGXOverrideFGStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'SetNGXOverrideFGState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFGXState: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetFGXStateParameters,
    Types.Share.Graphicssetting.GetFGXStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetFGXState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFGXDynamicState: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetFGXDynamicStateParameters,
    Types.Share.Graphicssetting.GetFGXDynamicStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetFGXDynamicState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetProfileSettingsForNvApp: BridgeCommands.Command<
    Types.Share.Graphicssetting.GetProfileSettingsForNvAppParameters,
    Types.Share.Graphicssetting.GetProfileSettingsForNvAppReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GraphicsSetting',
    method: 'GetProfileSettingsForNvApp',
    persistent: false
};

export const Graphicssetting = {
GetAIDVCSupport,
GetAIDVCState,
SetAIDVCState,
GetRealtimeAIDVCState,
ToggleNIS2,
GetNIS2State,
SetNIS2Sharpen,
GetAIHDRSupport_V2,
GetAIHDRDisplayInfoForProcess,
GetAIHDRRealTimeState,
GetAIHDRState_V2,
SetAIHDRState_V2,
GetGPUInfo,
GetGenericInfo,
GetUserPreferredLanguage,
RegisterUserPreferredLanguageChangeNotification,
UserPreferredLanguageChangeNotification,
DlssOnGameLaunched,
GetNGXOverrideSRState,
GetNGXOverrideRRState,
GetNGXOverrideFGState,
SetNGXOverrideFGState,
GetFGXState,
GetFGXDynamicState,
GetProfileSettingsForNvApp
};
